import {UICalendarState} from './types';

export const getInitialState = (): UICalendarState => ({
  isLoading: false,
  isRefreshing: false,
  loadingState: 'NotLoaded',
  timestamp: new Date().toISOString(),
});
